export const SHEET_SCRIPT = `function clean(v){
  v = String(v || '').slice(0, 200);
  return /^[=+\\-@]/.test(v) ? "'" + v : v;
}
function addRow(d){
  var sh = SpreadsheetApp.getActiveSpreadsheet().getSheets()[0];
  if (sh.getLastRow() === 0) {
    sh.appendRow(['Time','Name','Instagram/Email','Pace','Why NOBO','Status']);
  }
  sh.appendRow([new Date(), clean(d.name), clean(d.contact), clean(d.pace), clean(d.why), 'Waitlisted']);
}
function doGet(){
  return ContentService.createTextOutput('NOBO endpoint is live');
}
function doPost(e){
  var lock = LockService.getScriptLock();
  lock.waitLock(10000);
  try {
    addRow(JSON.parse(e.postData.contents));
    return ContentService.createTextOutput('ok');
  } catch (err) {
    return ContentService.createTextOutput('error: ' + err.message);
  } finally {
    lock.releaseLock();
  }
}
function testRow(){
  addRow({name:'Test Runner', contact:'@test', pace:'steady', why:'testing'});
}
`;

export const SHEET_STEPS = [
  {
    title: "Use a computer, with only the NOBO account signed in",
    body: "The Google Sheets phone app has no script editor. On a laptop, open a private / incognito window and sign in to Google with northbombayrunclub@gmail.com only. Being signed in to two Google accounts at once is the most common reason scripts break.",
  },
  {
    title: "Open your sheet, then Extensions → Apps Script",
    body: "Go to sheets.google.com and open the NOBO sheet. In the menu bar at the top (File, Edit, View, Insert, Format, Data, Tools, Extensions) click Extensions → Apps Script. No menu bar? Click the small ˅ arrow at the top right to show the menus. If the file name ends in .xlsx, first click File → Save as Google Sheets and use the new copy.",
  },
  {
    title: "Replace the code and save",
    body: "A new tab opens with a file called Code.gs. Click inside the code, press Ctrl+A (Cmd+A on Mac) and Delete. Tap 'copy script' below, paste it in, then click the save icon (floppy disk).",
  },
  {
    title: "Run testRow and allow access",
    body: "In the toolbar, pick testRow from the dropdown next to Debug, then click Run. A box says 'Authorization required': click Review permissions, choose northbombayrunclub@gmail.com. On 'Google hasn't verified this app' click Advanced (small link, bottom left) → Go to Untitled project (unsafe) → Allow. Check your sheet: a 'Test Runner' row appears.",
  },
  {
    title: "Deploy as a Web App",
    body: "Top right: Deploy → New deployment. Click the gear next to 'Select type' → Web app. Set Execute as: Me, Who has access: Anyone. Click Deploy, then Authorize access again if asked. Copy the Web app URL (ends in /exec).",
  },
  {
    title: "Paste the link below",
    body: "Paste the /exec link into the box below and tap 'save & test'. Once it says connected, tap 'send missing to Google Sheet' to copy every earlier sign-up across.",
  },
];
